module.exports = __webpack_public_path__ + "img/bsidd-6.20393ff3.jpg";